import { animate } from 'motion';

document.addEventListener('DOMContentLoaded', () => {
  const loadMoreButtons = document.querySelectorAll('.js-team-list-load-more');
  if (!loadMoreButtons.length) return;

  loadMoreButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const list = button
        .closest('.b-team-list')
        .querySelector('.js-team-list-items');

      const ids = list.getAttribute('data-more-ids');
      if (!ids) return;

      const postIds = JSON.parse(ids);

      button.classList.add('is-loading');
      button.disabled = true;

      fetch(window.wpAjaxUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=load_more_team&ids=${postIds}`,
      })
        .then((response) => response.text())
        .then((data) => {
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = data;

          const newItems = Array.from(tempContainer.children);
          newItems.forEach((item, index) => {
            list.appendChild(item);
            animate(
              item,
              {
                opacity: [0, 1],
                y: [20, 0],
              },
              {
                duration: 0.3,
                delay: index * 0.1, // stagger effect
              },
            );
          });

          button.style.display = 'none';
        })
        .finally(() => {
          button.classList.remove('is-loading');
        });
    });
  });
});
